import {META_TEXT_MENTION_PATTERN} from '../constants/metaTextMentionPattern';
import {toPlainLabel} from './toPlainLabel';

/**
 * Plain-text form of a META_TEXT cell value, used for clipboard copy. Mention
 * markup collapses to its display label (`@[John Doe](user-1)` → `John Doe`)
 * so the copied text matches what the cell renders.
 *
 * Notes are free-form and may contain newlines or tabs, which are the TSV row and
 * column separators — left as-is they would shift every following column and inject
 * phantom rows into the pasted output. Whitespace is collapsed to single spaces,
 * matching the single-line cell the grid actually renders.
 *
 * META_TEXT cells carry a plain string (TEXT column, METATEXT renderer); the
 * `toPlainLabel` fallback keeps a non-string value from stringifying to
 * "[object Object]".
 */
export const toMetaTextPlainText = (value: unknown): string =>
  typeof value === 'string'
    ? value.replace(META_TEXT_MENTION_PATTERN, '$1').replace(/\s+/g, ' ').trim()
    : toPlainLabel(value);
